import React from 'react'
import PropTypes from 'prop-types'
import ModalWizard from 'components/modal_wizard'
import { withRouter } from 'react-router'
import { routerShape, locationShape } from 'react-router/lib/PropTypes'

import { exitGlimpse, isForward } from 'lib/glimpse'

class ChipInGlimpse extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    onUnmount: PropTypes.func,
    operatingRemotely: PropTypes.bool,
    children: PropTypes.any,
    routes: PropTypes.array.isRequired,
    location: locationShape.isRequired,
    router: routerShape.isRequired,
    campaignId: PropTypes.string,
  }

  handleClose = () => {
    exitGlimpse('chip_in', this.props.router)
  }

  componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount()
    }
  }

  render() {
    const child = React.Children.only(this.props.children)
    const stepName = this.props.routes[this.props.routes.length - 1].path

    return (
      <ModalWizard
        movingForward={isForward(this.props.location)}
        glimpse={true}
        showSpinner={this.props.operatingRemotely}
        hideBack={!stepName || stepName === 'complete'}
        onClose={this.handleClose}
      >
        {React.cloneElement(child, { key: stepName })}
      </ModalWizard>
    )
  }
}

export default withRouter(ChipInGlimpse)
